import React from 'react';
import '../styles/PanelHorizontal.css'; 

const PanelHorizontal = ({ children, height }) => {
  return <div className="panel-horizontal" style={{ height: height }}>{children}</div>;
};

export default PanelHorizontal;